import {
   ChangeDetectorRef,
   Component,
   ElementRef,
   Input,
   OnChanges,
   OnInit,
   SimpleChanges,
   ViewContainerRef,
} from '@angular/core';
import { ExternalNumberDetail } from 'src/app/pages/extension-details/models/extension-detail-view.model';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { formatPhoneNumbers } from 'src/app/pipes/format-phone-numbers/format-phone-numbers.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: ExtensionAndExternalNumbersSelectComponent,
        },
    ],
    selector: 'ndt-extension-and-external-numbers-select',
    templateUrl: './extension-and-external-numbers-select.component.html',
    standalone: false
})
export class ExtensionAndExternalNumbersSelectComponent
   extends LcsSingleSelectBase<ExternalNumberDetail | ExtensionOption>
   implements OnInit, OnChanges
{
   @Input() extensionIdsToExclude: number[] = [];

   @Input() externalNumbers: ExternalNumberDetail[] = [];

   @Input() extensions: ExtensionOption[] = [];

   filteredOptions: (ExternalNumberDetail | ExtensionOption)[] = [];

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.updateFilteredOptions();
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes['extensionIdsToExclude'] || changes['extensions'] || changes['externalNumbers']) {
         this.updateFilteredOptions();
         this.changeDetectorRef.markForCheck();
      }
   }
   updateFilteredOptions(): void {
      const filteredExtensions = this.extensions.filter(
         (ext) => !Array.isArray(this.extensionIdsToExclude) || !this.extensionIdsToExclude.includes(ext.extensionId)
      );

      this.filteredOptions = [...this.externalNumbers, ...filteredExtensions];
   }

   displayWith(item: ExternalNumberDetail | ExtensionOption | null): string | null {
      if (!item) return null;
      if (this.isExternalNumber(item)) {
         let phoneNumber = formatPhoneNumbers(item.externalNumber.toString());
         if (!item.externalNumber || phoneNumber === '') {
            return null;
         }
         return `${phoneNumber} (Outside Line)`;
      } else {
         return item.name ? `${item.number} - ${item.name}` : null;
      }
   }

   trackBy = (item: ExternalNumberDetail | ExtensionOption | null): any => {
      if (item === null || typeof item !== 'object') {
         return null;
      }
      return 'externalNumberHistoryId' in item ? item.externalNumberHistoryId : item.extensionId;
   };

   public isExternalNumber(item: ExternalNumberDetail | ExtensionOption): item is ExternalNumberDetail {
      return 'externalNumberHistoryId' in item;
   }
}
